import { render, staticRenderFns } from "./HolDings.vue?vue&type=template&id=f664ff96"
import script from "./HolDings.vue?vue&type=script&lang=js"
export * from "./HolDings.vue?vue&type=script&lang=js"
import style0 from "./HolDings.vue?vue&type=style&index=0&id=f664ff96&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports